export default "__VITE_ASSET__BQ226zF5__"